export enum StepProgressState {
  ACTIVE,
  COMPLETED,
  ERROR,
}
